var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 101,
  height: 101,
  viewBox: "0 0 101 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.80163,
  cx: 50.5,
  cy: 50.5,
  r: 50,
  fill: "#2C4692",
  stroke: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73.8333 50.5L38.8333 70.5V30.5L73.8333 50.5Z",
  fill: "white",
  stroke: "white"
})));
export default SvgPlayButton;